import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import ReportValue from "@frameworks/web/components/generic/commonTableVal";
import React from "react";
import { stock } from "../../NFO/NFOConstant";
import { EMutualFundFlow } from "../../MutualFund/MutualFund";
const StockQuoteHeader = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: props.parentClassName },
            React.createElement("div", { className: "d-flex align-items-center DMSansMedium_16_500 txt_blackOne1 line-140" }, props.stockTitle),
            React.createElement("div", { className: "d-flex justify-content-between align-items-center DMSan_14_500 txt_blackOne1 mt-1 " },
                React.createElement("div", null,
                    props.payout,
                    React.createElement(EdButton, { btnTyp: "midnight-blue-underline", className: "change-button-custom ms-2", value: "Change", onClick: () => props.setChanges(EMutualFundFlow.SCHEME) })),
                React.createElement("div", null,
                    React.createElement(ReportValue, { val: props.ltp, stream: false, onlyval: false, parentClass: "txt_blackOne1 RobotoM_14_500 line-130" }),
                    props.hideAdditionalDetails ? null : (React.createElement("span", { className: "d-flex px-0 pt-0 DMSanM_10_500 $Primary-gray mb-0 stocksection" },
                        "Nav as on ",
                        props.navDate)))),
            React.createElement("div", { className: "flex-column  mt-0 d-flex" },
                React.createElement("ul", { className: "d-inline-flex px-0 DMSanM_10_500 $Primary-gray mb-0 stocksection" }, stock.map((items) => {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("li", null, items.title)));
                }))))));
};
export default StockQuoteHeader;
